// Lib
import styled from "styled-components";
import { Layout, Menu } from "antd";
// Theme
import { theme } from "theme";

const { Sider, Content } = Layout;

export const Wrapper = styled(Layout)`
  min-height: 100vh;
  background-color: transparent;
`;

export const AntDLayout = styled(Layout)`
  background-color: transparent;
`;

export const Sidebar = styled(Sider)`
  overflow: auto !important;
  height: 100vh !important;
  position: fixed !important;
  left: 0 !important;
  top: 0 !important;
  bottom: 0 !important;

  background: ${theme.color.white} !important;
  border-right: 1px solid ${theme.color.borderLight};

  .ant-layout-sider-children {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: white;
    padding-top: 64px;
  }
`;

export const MenuContainer = styled(Menu)<{
  $сollapsebutton?: boolean;
  $active?: boolean;
  $collapsed?: boolean;
}>`
  padding-top: 16px;
  border-inline-end: none !important;

  :where(.css-dev-only-do-not-override-hjgku5).ant-menu-light.ant-menu-inline
    .ant-menu-sub.ant-menu-inline,
  :where(.css-dev-only-do-not-override-hjgku5).ant-menu-light
    > .ant-menu.ant-menu-inline
    .ant-menu-sub.ant-menu-inline {
    background: white;
  }

  ${({ $сollapsebutton }) =>
    $сollapsebutton &&
    `padding: 8px 0; border-top: 1px solid ${theme.color.borderLight};`}

  .ant-menu-submenu-title {
    display: flex !important;
    align-items: center !important;
    width: auto !important;
    margin: 0 16px !important;
    height: auto !important;
    border-radius: 8px !important;

    &:active {
      background-color: ${theme.color.borderLight} !important;
    }
    ${({ $active }) =>
      $active && `background: ${theme.color.borderLight} !important;`};
    ${({ $collapsed }) =>
      $collapsed
        ? `padding: 12px 14px !important;`
        : `padding: 12px 16px !important;`};

    ${({ $сollapsebutton }) =>
      $сollapsebutton &&
      `flex-direction: row-reverse !important; 
    margin: 8 16px !important;
    height: 48px !important;
    &:hover {
      background: ${theme.color.borderLight} !important;
    };
    .ant-menu-title-content {
      margin-left: 0 !important;
    };`};

    ${({ $сollapsebutton, $collapsed }) =>
      $сollapsebutton &&
      $collapsed &&
      `.ant-menu-title-content: {
      transition: width 0s cubic-bezier(0.2, 0, 0, 1) 0s !important
    };`};

    line-height: ${theme.lineHeight.md} !important;
    font-size: ${theme.fontSize.md} !important;
    font-weight: ${theme.fontWeight.regular} !important;

    svg {
      height: 20px !important;
      width: 20px !important;
      min-width: 20px !important;
      line-height: ${theme.lineHeight.md} !important;
      font-size: ${theme.fontSize.md} !important;
    }
  }

  .ant-menu-sub {
    background: white !important ;
  }
`;

export const ContentContainer = styled(Content)`
  padding: 32px;
  min-height: calc(100vh-64px);
  position: relative;
`;

export const MenuItem = styled(Menu.Item)<{
  $active?: boolean;
  $collapsed?: boolean;
  $сollapsebutton?: boolean;
  $submenu?: boolean;
}>`
  display: flex !important;
  align-items: center !important;
  width: auto !important;
  margin: 0 16px !important;
  height: auto !important;
  border-radius: 8px !important;

  &:active {
    background-color: ${theme.color.borderLight} !important;
  }
  ${({ $active }) =>
    $active && `background: ${theme.color.borderLight} !important;`};

  ${({ $collapsed, $submenu }) =>
    $collapsed
      ? `padding: 12px 14px !important;`
      : $submenu
      ? `padding: 12px 16px 12px 48px !important;`
      : `padding: 12px 16px !important;`};

  ${({ $сollapsebutton }) =>
    $сollapsebutton &&
    `flex-direction: row-reverse !important; 
    margin: 8 16px !important;
    height: 48px !important;
    &:hover {
      background: ${theme.color.borderLight} !important;
    };
    .ant-menu-title-content {
      margin-left: 0 !important;
    };`};

  ${({ $сollapsebutton, $collapsed }) =>
    $сollapsebutton &&
    $collapsed &&
    `.ant-menu-title-content: {
      transition: width 0s cubic-bezier(0.2, 0, 0, 1) 0s !important
    };`};

  line-height: ${theme.lineHeight.md} !important;
  font-size: ${theme.fontSize.md} !important;
  font-weight: ${theme.fontWeight.regular} !important;

  svg {
    height: 20px !important;
    width: 20px !important;
    min-width: 20px !important;
    line-height: ${theme.lineHeight.md} !important;
    font-size: ${theme.fontSize.md} !important;
  }
`;
